// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';
import Timelapse from './Timelapse';
import Payout from './Payout';

export default class PayoutList extends ApiObject {

  timelapse: Timelapse = new Timelapse();

  payouts: Array<Payout> = []; // Array of Payin

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize timelapse
    this.timelapse = new Timelapse();
    this.timelapse.setFromTime(data.fromTime / 1000);
    this.timelapse.setToTime(data.toTime / 1000);

    // -- deserialize payins
    this.payouts = [];

    _.each(data.payouts, (payoutData: Object) => {
      const payout: Payout = new Payout();
      payout.fromJson(payoutData);
      this.payouts.push(payout);
    });
  }
}
